import NotificationsAdapter from './base';

export default class Subscription extends NotificationsAdapter {
  modelNamePlural = 'subscriptions';
}
